<template lang="pug">
	div
		#sfc-main-container.sfc-container-redesign-v1
			sfc-sentry
			sfc-hello-bar-v3
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-login
			sfc-forgot-password
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			#sfc-main-content
				nuxt
		sfc-college-savings-questions-modal
</template>


<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#sfc-main-container
		background-color: sfc-pale-stone
		height: 100vh
</style>


<script>
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'

export default {
	components: {
		SfcMenu,
		SfcMenuMobile,
		SfcFooter,
		sfcCollegeSavingsQuestionsModal,
		SfcHelloBarV3,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2
	}
}
</script>
